//
//  expertise.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class Expertise extends Vue {

    @Prop(String) private readonly context!: string;

}
